
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/_theatrical-pif/[slug]/[region]",
      function () {
        return require("private-next-pages/[locale]/_theatrical-pif/[slug]/[region]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/_theatrical-pif/[slug]/[region]"])
      });
    }
  